"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpellData = exports.getSpellStats = void 0;
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueSpellData_sidecar_1 = require("./rogueSpellData-sidecar");
var key = 'water-hands';
var getSpellStats = function () {
    return rogueSpellData_sidecar_1.rogueSpellData.getSpellStats(key);
};
exports.getSpellStats = getSpellStats;
function getSpellData() {
    return {
        key: key,
        name: 'Water Hands',
        desc: 'Punch out fires',
        castType: 'self',
        targetFinder: 'self',
        targetCursor: null,
        selfCast: function () {
            rogueStats_sidecar_1.rogueStats.castWaterHands();
        },
        hotkey: 'h',
        isBought: false,
        cost: 2,
        maxUses: 5,
        usesLeft: 0,
        baseDamage: 2,
        baseRange: 0,
        baseRadius: 0,
        duration: 15,
        upgrades: [
            {
                key: 'duration',
                name: '',
                effectAmount: 15,
                cost: 2,
                isBought: false,
            },
        ],
    };
}
exports.getSpellData = getSpellData;
